import { apiGetGroup } from "@app/api";

export async function getGroupIsSignatureRequired(
  groupId: string,
): Promise<boolean> {
  try {
    const response = await apiGetGroup(groupId);
    return response.data?.data?.isSignatureRequired ?? true;
  } catch (error) {
    console.error("Failed to fetch group signature requirement:", error);
    return true;
  }
}
